<div class="container">
  <icn-color-picker [value]="getColorValue()" (valueChange)="setColorValue($event)"> </icn-color-picker>
  <div class="label">{{ colorField.label }}</div>
</div>
